import "./styles.scss";

import { useTranslation } from "react-i18next";

import ModalNew from "components/ModalNew";
import SelectablePill from "components/SelectablePill";
import NeedHelp from "../NeedHelp";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "faq-content-modal";

const FaqContentModal = ({ data, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  return (
    <ModalNew
      title={max.sm ? t('FAQ - Frequently Asked Questions')  : data?.title}
      variant="wide"
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <div className={`${mainClass}__body`}>
          {data?.title && max.sm && <h6>{data.title}</h6>}
          <div className={`${mainClass}__category`}>
            <p>{t("Category")}</p>
            <SelectablePill data={data?.category} />
          </div>
          {data?.content && (
            <div className={`${mainClass}__content`}>
              <p>{t("Explanation")}</p>
              <p dangerouslySetInnerHTML={{ __html: data.content }} />
            </div>
          )}
        </div>
        {max.sm && (
          <div className={`${mainClass}__need-help`}>
            <NeedHelp />
          </div>
        )}
      </div>
    </ModalNew>
  );
};

export default FaqContentModal;
